// typescript
// File: `src/AsyncComponents.tsx`
import * as React from "react";
import loadable from '@loadable/component';
import { Button } from "react-bootstrap";
import queryString from "query-string";
import { translateService } from "./services/TranslateService";

interface LoadingComponentProps {
  isLoading?: boolean;
  pastDelay?: boolean;
  timedOut?: boolean;
  error?: any;
}

const LoadingComponent: React.FC<LoadingComponentProps> = (lc) => {
  const doRetry = () => (window.location.href = window.location.href + "");

  if (lc?.error) {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
      console.error(lc.error);

    return (
        <div>
          <div>Error!</div>
          <div className="btnDiv">
            <Button onClick={doRetry}>Retry</Button>
          </div>
        </div>
    );
  } else if (lc?.timedOut) {
    return (
        <div>
          <div>Taking a long time...</div>
          <div className="btnDiv">
            <Button onClick={doRetry}>Retry</Button>
          </div>
        </div>
    );
  } else if (lc?.pastDelay) {
    return (
        <div className="main-loader">
          <svg
              className="loader-spinner"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
          >
            <circle cx="25" cy="25" r="20" />
          </svg>
          <p>Loading Reservation...</p>
        </div>
    );
  } else {
    return null;
  }
};

// Single loadable for the RootContainer default export
const RootContainerLoader = loadable(
    () => import("./components/RootContainer/RootContainer"),
    { fallback: <LoadingComponent /> }
);

export const AsyncMakeReservation: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = urlParams.get("h") || "";
  const customerId = urlParams.get("c") || "";
  return (
      <RootContainerLoader
          content="makereservation"
          title={translateService.translate("rootContainer.reservations")}
          hash={hash}
          customer_id={parseInt(customerId)}
      />
  );
};

export const AsyncReceipt: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = urlParams.get("h") || undefined;
  const customer_id = urlParams.get("c") || "";
  const language = urlParams.get("lang") ?? sessionStorage.getItem('language');
  let resId = window.location.pathname.slice(1);
  resId = resId.slice(resId.indexOf('/') + 1);

  return (
      <RootContainerLoader
          content="receipt"
          hash={hash}
          customer_id={parseInt(customer_id)}
          reservation_id={parseInt(resId)}
          urlLanguage={language !== null ? language : undefined}
          title={`Receipt #${parseInt(resId)}`}
      />
  );
};

export const AsyncDeposit: React.FC = () => (
    <RootContainerLoader
        content="deposit"
        title={translateService.translate("rootContainer.deposit")}
    />
);

export const AsyncUnpaidBalance: React.FC = () => (
    <RootContainerLoader
        content="unpaidBalance"
        title={translateService.translate("rootContainer.unpaidBalance")}
    />
);

export const AsyncPaymentScreen: React.FC = () => {
  const searchParams = new URLSearchParams(document.location.search);
  let loc = window.location.pathname.slice(1);
  const paymentId = loc.slice(loc.indexOf('/') + 1).split('/')[0];
  const paymentStatus = searchParams.get("checkout-status") ?? undefined;

  return (
      <RootContainerLoader
          content="paymentscreen"
          title={translateService.translate("rootContainer.payment")}
          paymentId={paymentId}
          paymentStatus={paymentStatus}
          queryStringValues={[queryString.parse(window.location.search)]}
      />
  );
};

export const AsyncMyInformation: React.FC = () => (
    <RootContainerLoader
        content="myInformation"
        title={translateService.translate("rootContainer.myInformation")}
    />
);
